/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInner } from './PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInner';
import {
    PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInnerFromJSON,
    PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInnerFromJSONTyped,
    PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInnerToJSON,
} from './PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInner';

/**
 * 
 * @export
 * @interface PostCheckoutFullfillmentShippingRequestFullfillmentShipping
 */
export interface PostCheckoutFullfillmentShippingRequestFullfillmentShipping {
    /**
     * 
     * @type {string}
     * @memberof PostCheckoutFullfillmentShippingRequestFullfillmentShipping
     */
    parcelId: string;
    /**
     * 
     * @type {Array<PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInner>}
     * @memberof PostCheckoutFullfillmentShippingRequestFullfillmentShipping
     */
    items: Array<PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInner>;
    /**
     * 
     * @type {string}
     * @memberof PostCheckoutFullfillmentShippingRequestFullfillmentShipping
     */
    shippingLineId: string;
    /**
     * 
     * @type {string}
     * @memberof PostCheckoutFullfillmentShippingRequestFullfillmentShipping
     */
    trackingNumber?: string;
}

/**
 * Check if a given object implements the PostCheckoutFullfillmentShippingRequestFullfillmentShipping interface.
 */
export function instanceOfPostCheckoutFullfillmentShippingRequestFullfillmentShipping(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parcelId" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "shippingLineId" in value;

    return isInstance;
}

export function PostCheckoutFullfillmentShippingRequestFullfillmentShippingFromJSON(json: any): PostCheckoutFullfillmentShippingRequestFullfillmentShipping {
    return PostCheckoutFullfillmentShippingRequestFullfillmentShippingFromJSONTyped(json, false);
}

export function PostCheckoutFullfillmentShippingRequestFullfillmentShippingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCheckoutFullfillmentShippingRequestFullfillmentShipping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parcelId': json['parcel_id'],
        'items': ((json['items'] as Array<any>).map(PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInnerFromJSON)),
        'shippingLineId': json['shipping_line_id'],
        'trackingNumber': !exists(json, 'tracking_number') ? undefined : json['tracking_number'],
    };
}

export function PostCheckoutFullfillmentShippingRequestFullfillmentShippingToJSON(value?: PostCheckoutFullfillmentShippingRequestFullfillmentShipping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parcel_id': value.parcelId,
        'items': ((value.items as Array<any>).map(PostCheckoutFullfillmentStockingRequestFullfillmentStockingsInnerToJSON)),
        'shipping_line_id': value.shippingLineId,
        'tracking_number': value.trackingNumber,
    };
}

